export const onClick = function() {
  var $element = $(this);
  var $parent = $element.parents($element.data('wrapper'));

  if ($parent.length !== 1) {
    return true;
  }

  $('#social-hub').remove();

  if ($element.toggleClass('active').hasClass('active')) {
    $element.after('<div id="social-hub""></div>');
    $parent.on('mouseleave', _onMouseLeave);
    _createHubPopover($element, $parent);
  }

  return false;
};

const _onMouseLeave = function() {
  $(this)
    .find('[rel="social-hub"]')
    .removeClass('active');
  $('#social-hub').remove();
  $(this).off('mouseleave', _onMouseLeave);
};

const _getFacebookUrl = function(url) {
  return '//www.facebook.com/sharer.php?u=' + url;
};

const _getTwitterUrl = function(url) {
  var text = __('Ideas para decorar tu hogar en Habitissimo');
  return '//twitter.com/share?url=' + url + '&text=' + encodeURIComponent(text);
};

const _getPinterestUrl = function(url, media) {
  var text = __('Ideas para decorar tu hogar en Habitissimo');
  return (
    '//pinterest.com/pin/create/button/?url=' +
    url +
    '&media=' +
    media +
    '&description=' +
    encodeURIComponent(text)
  );
};

const _createHubPopover = function(element, parent) {
  var $hub = $('#social-hub');

  if (element.hasClass('top')) {
    $hub.addClass('top');
  } else if (element.hasClass('bottom')) {
    $hub.addClass('bottom');
  }

  $hub.append('<div class="arrow"></div>');
  $hub.append(
    '<a href="#" class="btn btn-secondary" rel="export-facebook" target="_blank"><i class="icon icon-facebook-o"></i> Facebook</a>'
  );
  $hub
    .find('[rel="export-facebook"]')
    .attr('href', _getFacebookUrl(element.data('url')));

  $hub.append(
    '<a href="#" class="btn btn-secondary" rel="export-twitter" target="_blank"><i class="icon icon-twitter-o"></i> Twitter</a>'
  );
  $hub
    .find('[rel="export-twitter"]')
    .attr('href', _getTwitterUrl(element.data('url')));

  var media = element.data('media');
  if (!media) {
    media = parent.find('img');
    media = media.length === 1 ? media.attr('src') : false;
  }

  if (media) {
    $hub.append(
      '<a href="#" class="btn btn-secondary" rel="export-pinterest" target="_blank"><i class="icon icon-pinterest-o"></i> Pinterest</a>'
    );
    $hub
      .find('[rel="export-pinterest"]')
      .attr('href', _getPinterestUrl(element.data('url'), media));
  }

  var position = _getHubPosition(element, $hub);
  $hub.css({
    top: position.top,
    left: position.left,
  });
};

const _getHubPosition = function(element, hub) {
  var position = element.position();

  position.left -= element.outerWidth() / 2;

  if (element.hasClass('top')) {
    position.top -= hub.outerHeight() + 22;
  } else if (element.hasClass('bottom')) {
    position.top += element.outerHeight() + 22;
  }

  return position;
};
